/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSettingsUnitCommand } from '../../models/update-settings-unit-command';
import { UpdateSettingsUnitCommandResult } from '../../models/update-settings-unit-command-result';

export interface ApiSettingsUnitsUpdateSettingsUnitPatch$Params {
      body?: UpdateSettingsUnitCommand
}

export function apiSettingsUnitsUpdateSettingsUnitPatch(http: HttpClient, rootUrl: string, params?: ApiSettingsUnitsUpdateSettingsUnitPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSettingsUnitCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSettingsUnitsUpdateSettingsUnitPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateSettingsUnitCommandResult>;
    })
  );
}

apiSettingsUnitsUpdateSettingsUnitPatch.PATH = '/api/SettingsUnits/UpdateSettingsUnit';
